import { Injectable } from '@angular/core';
import { CfgService } from '../../cfg/cfg.service';
import { HttpBackend } from '@angular/common/http';

export class GoogleLoginManagerCfg {
  public googleAccount: string;
  public redirectUri: string;
  public googleScope: string;
}

@Injectable({
  providedIn: 'root'
})
export class GoogleLoginCfgService extends CfgService<GoogleLoginManagerCfg> {
  protected exclude: boolean = true;

  constructor(httpBackend: HttpBackend,) {
    super(httpBackend);
  }

  protected getCfgFile(): string {
    return `/cfg/glogin.cfg.json`;
  }
}
